<i18n>
  {
    "ru": {
      "logo": "Обувь",
      "cities": {
        "kiev": "Киев",
        "dp": "Днепр"
      },
      "slogan": "сеть обувных порталов",
      "account": "Личный кабинет",
      "logout": "Выход",
      "navigation": "Навигация",
      "partners": "Партнёры",
      "news": "Новости",
      "directory": "Справочная",
      "footwear": "Обувь",
      "bags": "Сумки",
      "accessories": "Аксессуары",
      "services": "Услуги",
      "bulletin_board": "Объявления",
      "another": "Другое"
    },
    "uk": {
      "logo": "Взуття",
      "cities": {
        "kiev": "Київ",
        "dp": "Дніпро"
      },
      "slogan": "мережа взуттєвих порталів",
      "account": "Особистий кабінет",
      "logout": "Вихід",
      "navigation": "Навігація",
      "partners": "Партнери",
      "news": "Новини",
      "directory": "Довідкова",
      "footwear": "Взуття",
      "bags": "Сумки",
      "accessories": "Аксесуари",
      "services": "Послуги",
      "bulletin_board": "Оголошення",
      "another": "Інше"
    }
  }
</i18n>

<template>
  <header class="mobile-nav">
    <div class="navbar-helper container-fluid">
      <div class="container npd" style="padding:0 15px;">
        <div class="mobile-vis mobile-header row">
          <div class="col-6">
            <div
              class="dropdown"
              v-if="
                $store.state.GlobalData.categories &&
                  $store.state.GlobalData.categories.length > 0
              "
            >
              <b-dropdown :text="this.localeShortName">
                <b-dropdown-item :to="changeLangLinkUk">
                  УКР
                </b-dropdown-item>
                <b-dropdown-item :to="changeLangLinkRU">
                  РУС
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="col-6" style="justify-content:flex-end;">
            <ul class="nav">
              <li v-if="$store.state.cart.length > 0">
                <router-link
                  class="nav-link cart-link"
                  :to="'/' + locale + '/cart'"
                >
                  <font-awesome-icon
                    class="as-icon"
                    :icon="['fas', 'shopping-cart']"
                  />
                  <span
                    class="badge badge-secondary"
                    v-show="$store.state.cart.length > 0"
                    >{{ $store.state.cart.length }}</span
                  >
                </router-link>
              </li>
              <li>
                <a
                  href="#"
                  @click.prevent="showMenu = !showMenu"
                  class="btn btn-secondary as-btn-collapse"
                >
                  <font-awesome-icon class="as-icon" :icon="['fas', 'bars']" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="mobile-hidden mobile-header flex">
          <ul
            class="nav as-lang-menu"
            style="justify-content:flex-start;width:30%;"
            v-if="
              $store.state.GlobalData.categories &&
                $store.state.GlobalData.categories.length > 0
            "
          >
            <li class="nav-item">
              <router-link class="nav-link" :to="changeLangLinkUk"
                >УКР</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="changeLangLinkRU"
                >РУС</router-link
              >
            </li>
          </ul>
          <ul class="nav" style="justify-content:flex-end;width:70%;">
            <li
              class="nav-item"
              v-if="
                $store.state.session.isAuth &&
                  $store.state.user &&
                  ($store.state.user.status === 1 ||
                    $store.state.user.status === 3)
              "
            >
              <Toolbar />
            </li>
            <li class="nav-item" v-if="!$store.state.session.isAuth">
              <ModalReg />
            </li>
            <li class="nav-item" v-if="!$store.state.session.isAuth">
              <ModalAuth />
            </li>
            <li class="nav-item" v-if="$store.state.session.isAuth">
              <router-link
                class="nav-link"
                :to="'/' + this.locale + '/account'"
              >
                {{ $t("account") }}
              </router-link>
            </li>
            <li class="nav-item" v-if="$store.state.session.isAuth">
              <a class="nav-link" href="#" @click.prevent="signOut">
                {{ $t("logout") }}
              </a>
            </li>
            <!--<li class="nav-item" v-if="$store.state.session.isAuth">
              <a class="nav-link" href="#">
                Сравнить
              </a>
            </li>-->
          </ul>
        </div>
      </div>
    </div>
    <div class="navbar-top container">
      <nav class="navbar">
        <div class="container-fluid">
          <div class="navbar-header" v-if="$store.state.GlobalData.cities">
            <router-link class="navbar-brand" :to="{ name: 'home' }">
              <div class="brand-img">
                <img
                  width="45"
                  alt="Obuv.info"
                  src="@/assets/images/logo.svg"
                />
              </div>
              <div class="brand-name">
                <p>{{ $t("logo") }} {{ getCity.name[locale] }}</p>
                <small>{{ $t("slogan") }}</small>
              </div>
            </router-link>
          </div>
          <Search />
          <Cart />
        </div>
      </nav>
    </div>
    <div class="navbar-bottom container-fluid navbar-blue">
      <nav class="navbar navbar-expand-lg container">
        <div class="as-menu col-sm-12 col-xl-3 npd">
          <a
            class="as-menu-name"
            href="/"
            v-if="isMobile"
            @click.prevent="hide = !hide"
          >
            <img
              src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10.979' fill='%23fff' width='26' height='16'%3E%3Cpath d='M0 0h16v2.183H0zM0 4.398h16v2.183H0zM0 8.796h16v2.183H0z'/%3E%3C/svg%3E"
            />
            {{ $t("navigation") }}
          </a>
          <router-link class="as-menu-name" to="/" v-else
            ><img
              src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10.979' fill='%23fff' width='26' height='16'%3E%3Cpath d='M0 0h16v2.183H0zM0 4.398h16v2.183H0zM0 8.796h16v2.183H0z'/%3E%3C/svg%3E"
            />
            {{ $t("navigation") }}</router-link
          >
          <div
            id="nav"
            class="as-menu-contant"
            v-if="$store.state.GlobalData.categories"
            v-show="!hide"
          >
            <ul class="nav flex-column">
              <li
                class="nav-item"
                v-for="cat in structCat"
                :key="cat.id"
                :class="{ dropdown: cat.subCat.length > 0 }"
              >
                <div class="as-nav-link">
                  <router-link
                    class="nav-link dropdown-toggle"
                    :to="'/' + locale + '/' + cat.url[locale]"
                  >
                    <img
                      :src="
                        require('../assets/images/menu/' +
                          cat.url['ru'] +
                          '.svg')
                      "
                    />
                    {{ cat.name[locale] }}
                  </router-link>
                  <span v-if="isMobile">
                    <font-awesome-icon
                      class="as-icon"
                      :icon="['fas', 'chevron-down']"
                    />
                  </span>
                </div>
                <div class="dropdown-menu" v-if="cat.adults.length > 0">
                  <div class="flex">
                    <div class="as-sub-menu">
                      <b-tabs class="as-nav-tabs">
                        <b-tab
                          :title="item.name[locale]"
                          v-for="item in $store.state.GlobalData.adults"
                          :key="item.id"
                        >
                          <ul class="as-sub-last">
                            <template v-for="subCat in cat.subCat">
                              <li
                                :key="subCat.id"
                                v-if="ifFilter(item.id, subCat.adults)"
                              >
                                <span>
                                  <router-link
                                    class="nav-link last-child"
                                    :to="
                                      '/' +
                                        locale +
                                        '/' +
                                        item.url[locale] +
                                        '/' +
                                        subCat.url[locale]
                                    "
                                    >{{ subCat.name[locale] }}</router-link
                                  >
                                </span>
                              </li>
                            </template>
                            <li>
                              <router-link
                                class="nav-link last-child"
                                :to="'/' + locale + '/' + item.url[locale]"
                                >Посмотреть всё</router-link
                              >
                            </li>
                          </ul>
                        </b-tab>
                      </b-tabs>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="nav flex-column mobile-hidden-nav">
              <li class="info">
                <span>{{ $t("another") }}</span>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :to="'/' + this.locale + '/partners'"
                  >{{ $t("partners") }}</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :to="'/' + this.locale + '/news'"
                  >{{ $t("news") }}</router-link
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">{{ $t("directory") }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="collapse navbar-collapse justify-content-end">
          <ul class="navbar-nav as-navbar-content">
            <li class="nav-item">
              <router-link
                class="nav-link"
                :to="'/' + this.locale + '/partners'"
                >{{ $t("partners") }}</router-link
              >
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="'/' + this.locale + '/news'">{{
                $t("news")
              }}</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">{{ $t("directory") }}</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <MobileNav :class="{ open: showMenu }" />
    <div
      @click="showMenu = !showMenu"
      class="as-backfone"
      :class="{ show: showMenu }"
    ></div>
  </header>
</template>

<script>
import Cart from "@/components/Cart.vue";
import Search from "@/components/Search.vue";
import ModalAuth from "@/components/modals/Auth.vue";
import ModalReg from "@/components/modals/Reg.vue";
import Toolbar from "@/components/cockpit/index.vue";
import MobileNav from "@/components/MobileNav.vue";

export default {
  computed: {
    getCity() {
      let cities = this.$store.state.GlobalData.cities;
      let city = {};
      if (window.location.hostname !== "localhost") {
        city = cities.find(f => {
          if (f.domains.indexOf(window.location.hostname) !== -1) {
            return f;
          }
        });
      } else {
        city = {
          name: { ru: "Днепр", uk: "Діпро" },
          domains: ["obuv.dp.ua"]
        };
      }

      return city;
    },
    changeLangLinkUk() {
      let cat = this.$store.state.GlobalData.categories;
      let adults = this.$store.state.GlobalData.adults;
      let arr = [];
      if (this.$route.name === "category" || this.$route.name === "sub-cat") {
        if (this.$route.params.catUri) {
          if (this.$route.params.catUri.indexOf("-") !== -1) {
            for (let a = 0; a < adults.length; a++) {
              if (
                this.$route.params.catUri === adults[a].url["ru"] ||
                this.$route.params.catUri === adults[a].url["uk"]
              ) {
                arr.push(adults[a].url["uk"]);
              }
            }
          } else {
            for (let c = 0; c < cat.length; c++) {
              if (
                this.$route.params.catUri === cat[c].url["ru"] ||
                this.$route.params.catUri === cat[c].url["uk"]
              ) {
                arr.push(cat[c].url["uk"]);
              }
            }
          }
        }
        if (this.$route.params.uri) {
          for (let c = 0; c < cat.length; c++) {
            if (
              this.$route.params.uri === cat[c].url["ru"] ||
              this.$route.params.uri === cat[c].url["uk"]
            ) {
              arr.push(cat[c].url["uk"]);
            }
          }
        }
        return (
          "/" + "uk" + (arr.length > 0 ? "/" + arr.join("/").toString() : "")
        );
      } else {
        return this.$route.path.replace("ru", "uk");
      }
    },
    changeLangLinkRU() {
      let cat = this.$store.state.GlobalData.categories;
      let adults = this.$store.state.GlobalData.adults;
      let arr = [];
      if (this.$route.name === "category" || this.$route.name === "sub-cat") {
        if (this.$route.params.catUri) {
          if (this.$route.params.catUri.indexOf("-") !== -1) {
            for (let a = 0; a < adults.length; a++) {
              if (
                this.$route.params.catUri === adults[a].url["uk"] ||
                this.$route.params.catUri === adults[a].url["ru"]
              ) {
                arr.push(adults[a].url["ru"]);
              }
            }
          } else {
            for (let c = 0; c < cat.length; c++) {
              if (
                this.$route.params.catUri === cat[c].url["uk"] ||
                this.$route.params.catUri === cat[c].url["ru"]
              ) {
                arr.push(cat[c].url["ru"]);
              }
            }
          }
        }
        if (this.$route.params.uri) {
          for (let c = 0; c < cat.length; c++) {
            if (
              this.$route.params.uri === cat[c].url["uk"] ||
              this.$route.params.uri === cat[c].url["ru"]
            ) {
              arr.push(cat[c].url["ru"]);
            }
          }
        }
        return (
          "/" + "ru" + (arr.length > 0 ? "/" + arr.join("/").toString() : "")
        );
      } else {
        return this.$route.path.replace("uk", "ru");
      }
    },
    structCat() {
      let newCat = [];
      let categories = this.$store.state.GlobalData.categories;
      for (let i = 0; i < categories.length; i++) {
        if (!categories[i].subCat) {
          categories[i].subCat = {};
        }
        if (categories[i].parent_id !== "0") {
          for (let c = 0; c < categories.length; c++) {
            if (categories[i].id === categories[c].parent_id) {
              categories[i].subCat[categories[c].id] = categories[c];
            }
          }
        }

        if (categories[i].parent_id === "0") {
          for (let s = 0; s < categories.length; s++) {
            if (categories[i].id === categories[s].parent_id) {
              categories[i].subCat[categories[s].id] = categories[s];
            }
          }
          newCat.push(categories[i]);
        }
      }
      return newCat;
    }
  },
  data() {
    let zone = "dp";
    switch (window.location.hostname.split(".")[1]) {
      case "kiev":
        zone = "kiev";
        break;
      case "od":
        zone = "od";
        break;
    }
    return {
      hide: true,
      showMenu: false,
      locale: this.$route.params.locale,
      localeShortName: null,
      domainZone: zone,
      redirect: false,
      isMobile: false,
      window: {
        width: 0
      }
    };
  },
  watch: {
    $route(to) {
      if (to.name === "product") {
        let history = localStorage.getItem("history")
          ? JSON.parse(localStorage.getItem("history"))
          : [];
        let find = history.find(f => f === to.params.id);
        if (!find) {
          history.push(to.params.id);
          localStorage.setItem("history", JSON.stringify(history));
        }
      }
      this.redirect = false;

      this.hide =
        this.$route.name !== "home"
          ? true
          : window.innerWidth >= 1280
          ? false
          : true;
      this.locale = to.params.locale;
      this.detectLocaleShortName();
      this.showMenu = false;
    }
  },
  methods: {
    ifFilter(id, arrId) {
      return arrId && arrId.indexOf(id) !== -1;
    },
    detectLocaleShortName() {
      switch (this.$route.params.locale) {
        case "uk":
          this.localeShortName = "УКР";
          break;
        case "ru":
          this.localeShortName = "РУС";
          break;
      }
    },
    signOut() {
      this.$auth.signOut(this.$store);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      if (window.innerWidth < 1280) {
        this.isMobile = true;
      }
    }
  },
  created() {
    this.detectLocaleShortName();
    this.hide =
      this.$route.name !== "home"
        ? true
        : window.innerWidth >= 1280
        ? false
        : true;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  components: {
    Cart,
    Search,
    ModalAuth,
    ModalReg,
    Toolbar,
    MobileNav
  }
};
</script>

<style scope>
@media (max-width: 1000px) {
  .container {
    max-width: 100% !important;
  }
  .navbar-brand .brand-name p {
    font-size: 24px !important;
  }
  .navbar-brand .brand-name small {
    font-size: 14px !important;
  }
}
@media screen and (max-width: 1280px) {
  .mobile-vis .dropdown button {
    background: #6c757d !important;
  }
}
</style>
